import { BASE_MONTH_VIEW_ID } from './use-big-calendar'

export const getMostDisplayedIdInDOM = (): string | null => {
  const mostVisibleIdInDOM = Array.from(
    document.querySelectorAll<HTMLElement>(`[id^="${BASE_MONTH_VIEW_ID}"]`),
  ).reduce<{
    div: HTMLElement | null
    area: number
  }>(
    (largest, div) => {
      const rect = div.getBoundingClientRect()

      const visibleArea =
        Math.max(
          0,
          Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0),
        ) *
        Math.max(
          0,
          Math.min(rect.right, window.innerWidth) - Math.max(rect.left, 0),
        )

      return visibleArea > largest.area ? { div, area: visibleArea } : largest
    },
    { div: null, area: 0 },
  ).div?.id

  return mostVisibleIdInDOM ?? null
}
